export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('countries');
    if (element) {
        if (element.length) {
            tourCriteriaJson.countries = element.pluck('id');
        } else {
            tourCriteriaJson.countries = [];
        }
    }

    return tourCriteriaJson;
};